import { VyRadioCardWrapper } from '../../../../../../../components/new-design/inputs/VyRadioCard/VyRadioCardWrapper.tsx';
import { FC, ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type CreditKindRadioCardProps = {
  title: string;
  icon: ReactNode;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export const CreditKindRadioCard: FC<CreditKindRadioCardProps> = ({
  title,
  icon,
  isSelected,
  onClick,
  disabled = false,
}) => {
  return (
    <VyRadioCardWrapper
      onClick={onClick}
      isSelected={isSelected}
      disabled={disabled}
      renderContent={(selected) => (
        <Stack spacing={0.5}>
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            {icon}
            {selected && <CheckCircleIcon sx={{ color: '#07105F' }} />}
          </Stack>
          <Typography sx={{ fontSize: '16px', fontWeight: '500', color: isSelected ? '#020F20' : '#5F6978' }}>
            {title}
          </Typography>
        </Stack>
      )}
    />
  );
};
